import React from 'react';
import FollowingGlobal from '../../common/following-global.js';

import './following.css';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2.js';
import { useMediaQuery } from '@mui/material';
import { ROLES } from '../../utils/constants.js';
import DefaultPUWidget from '../../Widgets/PU/Default/index.js';
import DefaultWidget from '../../Widgets/SU/Default/index.js';
import { connect } from 'react-redux';

const Following = ({
    user
}) => {
    const isMobile = useMediaQuery('(max-width: 899px)');
    return (
        <div className="container mb-4 mt-4">
            <Grid2
                container
                spacing={!isMobile ? 2 : 0}
            >
                <Grid2 md={8}>
                    <FollowingGlobal />
                </Grid2>

                {
                    !isMobile
                        ? <Grid2 className='pu-homepage__right' md={4}>
                            {
                                user && user.role == ROLES.PU ? <DefaultPUWidget /> : null
                            }
                            {
                                user && user.role == ROLES.SU ? <DefaultWidget /> : null
                            }
                        </Grid2>
                        : null
                }
            </Grid2>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.user.user,
    };
};

export default connect(mapStateToProps)(Following);
